/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { EmptyResponse } from '../../models/empty-response';

export interface CommentControllerCleanup$Params {
  monitoringId: number;
  id: number;
}

export function commentControllerCleanup(http: HttpClient, rootUrl: string, params: CommentControllerCleanup$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, commentControllerCleanup.PATH, 'delete');
  if (params) {
    rb.path('monitoringId', params.monitoringId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: EmptyResponse;
      }>;
    })
  );
}

commentControllerCleanup.PATH = '/monitoring/{monitoringId}/comments/{id}/cleanup';
